import React, { useState, useEffect } from "react";
import Shell from "components/Shell";
import { getActiveCampaigns, getAll } from "api";
import { CAMPAIGN_NAMES, HEADERS } from "config";
import { getExcludedCategories } from "helpers";

const props = {
  adFormatName: CAMPAIGN_NAMES.SLIDE,
  tableHeaders: HEADERS.SLIDE,
};

export default () => {
  const [data, setData] = useState([]);
  const [otherCampaignsData, setOtherCampaignsData] = useState([]);

  const refresh = () => {
    getAll(CAMPAIGN_NAMES.SLIDE.short)
      .then((data) => setData(data?.ads ?? []))
      .catch(console.log);

    Promise.all([
      getActiveCampaigns(CAMPAIGN_NAMES.SWIPEUP.short).catch(() => ({
        ads: [],
      })),
      getActiveCampaigns(CAMPAIGN_NAMES.NOTIFAD.short).catch(() => ({
        ads: [],
      })),
    ])
      .then(([swipeUpRes, notifAdRes]) => {
        const combinedActive = [
          ...(swipeUpRes?.ads ?? []),
          ...(notifAdRes?.ads ?? []),
        ];
        setOtherCampaignsData(combinedActive);
      })
      .catch(console.log);
  };

  const excludedCategoryValues = getExcludedCategories(otherCampaignsData);

  useEffect(() => {
    refresh();
  }, []);

  return (
    <Shell
      {...props}
      campaignsData={data}
      refresh={refresh}
      excludedCategoryValues={excludedCategoryValues}
    />
  );
};
